import { createFileRoute, redirect } from '@tanstack/react-router'

import { getDefaultUserMeTenant } from '@/features/auth/models'

export const Route = createFileRoute('/_protected/')({
  beforeLoad: ({ context }) => {
    // '/' にアクセスされた場合は、デフォルトテナントのキーにリダイレクト
    const { user } = context.auth

    throw redirect({
      to: `/${getDefaultUserMeTenant(user).key}`
    })
  }
})
